import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import { store } from "../../redux/store";
import Searchable from 'react-searchable-dropdown';
import Select from 'react-select'
import { setStateDetails, setBranchList, setBranchAddress, setSelectedBankName, setSelectedBankId } from '../../redux/misc-data/misc-data.action';
import { setCityList } from "../../redux/misc-data/misc-data.action";
import { setIfscCode } from "../../redux/misc-data/misc-data.action";
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import FooterComponet from "../FooterComponent/FooterComponet";
const httpClient = axios.create();
class AddAccountIfsc extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			selecetedState: '',
			stateSelectMessage: '',
			selecetedCity: '',
			citySelectMessage: '',
			stateValues: [],
			cityValues: [],
			branchValues: [],
			cityList: [],
			stateList: [],
			branchList: [],
			searchableStateList: [],
			searchableCityList: [],
			searchableBranchList: [],
			cityDetails: '',
			branchDetails: '',
			showCityDiv: false,
			showBranchDiv: false,
			errorMessage: ''
		}
	}


	componentDidMount() {

		this.setState({
			errorMessage: ''
		})
		store.dispatch(setIfscCode(''));
		store.dispatch(setBranchAddress(''));
		store.dispatch(setBranchList(''));
		store.dispatch(setCityList(''));
		// var bankId=this.props.selectedBankDetails.selectedBankId;
		var bankId = this.props.selectedBankId;

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		var bankDetailsUrl = '/api/v1/catalog/bank/' + bankId;
		httpClient.get(bankDetailsUrl, { headers }
		).then((response) => {
			console.log('seleceted bank details' + JSON.stringify(response.data));
			if (response.data.states.length > 0) {
				var stateList = [];
				response.data.states.map(state => {
					stateList.push(state)
				})


				var searchableStateList = [];

				stateList.map(state => {
					var stateVal = {
						value: '',
						label: ''
					}
					stateVal.value = state.name;
					stateVal.label = state.name;
					searchableStateList.push(stateVal);
				})

				this.setState({
					bankDetails: response.data,
					searchableStateList: searchableStateList
				})

				store.dispatch(setStateDetails(searchableStateList))
			}
		}
		).catch(error => {
			this.setState({
				errorMessage: 'Something went wrong,please try again later!'
			})
			
			if(error.message.includes("401")){
				tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
			}
			

		});
	}

	componentWillUnmount() {
	}


	addBeneficiary = () => {
		store.dispatch(setIfscCode(''));
		store.dispatch(setBranchAddress(''));
		store.dispatch(setSelectedBankName(''));

		var addBeneBtn = document.getElementById('addBeneBtn');
		addBeneBtn.click();
	}


	stateChange = (selected) => {
		store.dispatch(setIfscCode(''));
		store.dispatch(setBranchAddress(''));

		if (selected.value == 'Select') {

			this.setState({
				stateSelectMessage: 'Please select a state'
			})
		} else {


			this.setState({
				selecetedState: selected.value,
				selecetedCity: '',
				selecetedBranch: ''
			})
			




			console.log('this.state.bankDetails::' + JSON.stringify(this.state.bankDetails));

			var cityList = [];
			this.state.bankDetails.states.map(state => {
				if (state.name == selected.value) {
					console.log('state name::' + state.name);
					this.setState({
						cityList: state.cities,
						showCityDiv: true,
						showBranchDiv: false
					})



					cityList.push(state.cities);

					store.dispatch(setCityList(state.cities));
				}
			})


			var searchableCityList = [];

			console.log('cityList:' + JSON.stringify(cityList));

			cityList[0].map(city => {
				var cityVal = {
					value: '',
					label: ''
				}
				console.log('city::' + JSON.stringify(city));
				cityVal.value = city.name;
				cityVal.label = city.name;
				searchableCityList.push(cityVal);
			})

			console.log('searchableCityList:' + JSON.stringify(searchableCityList));

			this.setState({
				cityDetails: cityList[0],
				searchableCityList: searchableCityList
			})




		}
	}


	cityChange = (selected) => {

		store.dispatch(setIfscCode(''));
		store.dispatch(setBranchAddress(''));


		if (selected.value == 'Select') {

			this.setState({
				citySelectMessage: 'Please select a city'
			})
		} else {
			this.setState({
				selecetedCity: selected.value,
				selecetedBranch: ''

			})

			console.log('cityDetails::' + JSON.stringify(this.state.cityDetails));

			var branchList = [];
			this.state.cityDetails != [] &&
				this.state.cityDetails.map(city => {
					if (city.name == selected.value) {
						console.log(city.name);
						this.setState({
							branchList: city.branches,
							showBranchDiv: true
						})

						branchList.push(city.branches);

						store.dispatch(setBranchList(city.branches));
					}
				})


			var searchableBranchList = [];

			console.log('branchList:' + JSON.stringify(branchList));

			branchList.length > 0 &&
				branchList[0].map(branch => {
					var branchVal = {
						value: '',
						label: ''
					}
					console.log('branch::' + JSON.stringify(branch));
					branchVal.value = branch.address;
					branchVal.label = branch.address;
					searchableBranchList.push(branchVal);
				})

			console.log('searchableBranchList:' + JSON.stringify(searchableBranchList));

			this.setState({
				branchDetails: branchList[0],

				searchableBranchList: searchableBranchList
			})




		}



	}


	branchChange = (selected) => {
		if (selected.value == 'Select') {

			this.setState({
				branchSelectMessage: 'Please select a city'
			})
		} else {
			this.setState({
				selecetedBranch: selected.value,
			})

			console.log('selecetde branch details:' + JSON.stringify(selected));



			console.log('branchDetails::' + JSON.stringify(this.state.branchDetails));


			this.state.branchDetails.map(branch => {
				if (branch.address == selected.value) {
					console.log(branch.address);
					this.setState({
						ifscCode: branch.ifsc
					})

					store.dispatch(setIfscCode(branch.ifsc.toUpperCase()));
					store.dispatch(setBranchAddress(branch.address));

				}
			})



		}
	}


	render() {


		var selecetedBankName = this.props.selectedBankName;

		// stateList=this.props.stateList;
		// cityList=this.props.cityList;
		// branchList=this.props.branchList;
		var ifscCode = '';
		ifscCode = this.props.ifscCode;



		return (

			<div>
				<HeadeCommon />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">


							<div class="row">
								<div class="col-12">
									<div class="card-b">
										<div id="recenttxn">
											<div class="head">
												<h3>Search IFSC Code</h3>
												<button class="dbbtn" onClick={this.addBeneficiary} type="button">Back</button>
											</div>
											<Link to='/add-account'>
												<button id='addBeneBtn' hidden={true}></button>
											</Link>
											{this.state.errorMessage != '' &&
												<div class='valid-error'>
													{this.state.errorMessage}
												</div>}

											<div class="dashform">
												<div class="row">

													<div class="col-12 col-sm-6 col-xl-5">
														<label for="bank">Bank Name</label>
														<div class="form-floating">
															<input type="text" class="form-control" id="code"
																value={selecetedBankName} readOnly>
															</input>

														</div>
													</div>



													{this.state.searchableStateList.length > 0 &&
														<div class="col-12 col-sm-6 col-xl-5">
															<label for="state">State</label>
															<div class="form-floating">



																<Select options={this.state.searchableStateList} class="form-control"

																	onChange={this.stateChange} />

															</div>
														</div>
													}
													{this.state.searchableCityList.length > 0 &&
														this.state.showCityDiv == true &&
														<div class="col-12 col-sm-6 col-xl-5">
															<label for="city">City</label>
															<div class="form-floating">

																<Select
																	options={this.state.searchableCityList}
																	defaultValue={{ label: this.state.selecetedCity, value: this.props.selecetedCity }}
																	class="form-control"

																	onChange={this.cityChange} />

															</div>
														</div>
													}



													{this.state.searchableBranchList.length > 0 &&
														this.state.showBranchDiv == true &&
														<div class="col-12 col-sm-6 col-xl-5">
															<label for="branch">Branch</label>
															<div class="form-floating">

																<Select options={this.state.searchableBranchList} class="form-control"
																	defaultValue={{ label: this.state.selecetedBranch, value: this.props.selecetedBranch }}
																	onChange={this.branchChange} />

															</div>
														</div>
													}


													{this.props.ifscCode != '' &&
														this.props.branchAddress != '' &&
														<div class="col-12 col-sm-6 col-lg-4">
															<div class="ifscodetxt">
																<h5>IFSC Code: <span>{this.props.ifscCode}</span></h5>
																<p>Branch: {this.props.branchAddress}</p>
															</div>
														</div>
													}

													{ifscCode != '' &&
														<div class="col-12">
															<Link to='/add-account'>
																<button type="button" class="btn btn-primary">Ok</button>
															</Link>
														</div>
													}

													{ifscCode == '' &&
														<div class="col-12">
															<button type="button" disabled class="btn btn-primary" >Ok</button>
														</div>
													}

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet/>

			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, selectedBankDetails, stateList, cityList, ifscCode,
			agentInfo, token,clientRole, selectedBankId, selectedBankName, bankDetails, 
			branchAddress,callBackUrl
		} }
) => ({
	errorMessage, loginErrorMessage, phone
	, selectedBankDetails, stateList, cityList, ifscCode, agentInfo, token,clientRole,
	selectedBankId, selectedBankName, bankDetails, branchAddress,callBackUrl
});

export default connect(mapStateToProps, null)(AddAccountIfsc);
